(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modelyard-beam-500"] && !Shopify.designMode) return;
  try {
    
  const beamRows = document.querySelectorAll('.forge-beam');

  beamRows.forEach((section) => {
    if (section.dataset.bound === 'true') return;
    section.dataset.bound = 'true';

    const row = section.querySelector('.forge-beam__row');
    const prev = section.querySelector('[data-beam-dir="-1"]');
    const next = section.querySelector('[data-beam-dir="1"]');
    const originals = [...row.querySelectorAll('video')];

    originals.forEach((video) => {
      const clone = video.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('src');
      row.appendChild(clone);
    });

    const videos = [...row.querySelectorAll('video')];

    const attachSource = (video) => {
      if (video.dataset.ready === 'true' || !video.dataset.src) return;
      video.dataset.ready = 'true';
      video.preload = 'metadata';
      video.src = video.dataset.src;
    };
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const speed = 48;
    let offset = 0;
    let last = 0;
    let inView = false;

    const loopWidth = () => {
      const clone = row.children[originals.length];
      return clone ? clone.offsetLeft : row.scrollWidth / 2;
    };

    const step = () => {
      const card = row.querySelector('video');
      if (!card) return 0;
      const styles = getComputedStyle(row);
      const gap = parseFloat(styles.columnGap || styles.gap) || 12;
      return card.getBoundingClientRect().width + gap;
    };

    const apply = () => {
      const width = loopWidth();
      if (width > 0) {
        offset %= width;
        if (offset < 0) offset += width;
      }
      row.scrollLeft = offset;
    };

    prev.addEventListener('click', () => {
      offset -= step();
      apply();
    });

    next.addEventListener('click', () => {
      offset += step();
      apply();
    });

    const tick = (now) => {
      if (!last) last = now;
      const delta = Math.min(now - last, 40);
      last = now;
      if (inView && !reduced) {
        offset += (speed * delta) / 1000;
        apply();
      }
      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);

    const sectionObserver = new IntersectionObserver((entries) => {
      inView = entries.some((entry) => entry.isIntersecting);
    }, { threshold: 0.35 });

    sectionObserver.observe(section);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!entry.isIntersecting) {
          video.pause();
          return;
        }
        attachSource(video);
        video.play().catch(() => {});
      });
    }, { rootMargin: '240px 320px', threshold: 0.01 });

    videos.forEach((video) => observer.observe(video));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modelyard-beam-home"] && !Shopify.designMode) return;
  try {
    
  const beamRows = document.querySelectorAll('.forge-beam');

  beamRows.forEach((section) => {
    if (section.dataset.bound === 'true') return;
    section.dataset.bound = 'true';

    const row = section.querySelector('.forge-beam__row');
    const prev = section.querySelector('[data-beam-dir="-1"]');
    const next = section.querySelector('[data-beam-dir="1"]');
    const originals = [...row.querySelectorAll('video')];

    originals.forEach((video) => {
      const clone = video.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      row.appendChild(clone);
    });

    const videos = row.querySelectorAll('video');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const speed = 48;
    let offset = 0;
    let last = 0;
    let inView = false;

    const loopWidth = () => {
      const clone = row.children[originals.length];
      return clone ? clone.offsetLeft : row.scrollWidth / 2;
    };

    const step = () => {
      const card = row.querySelector('video');
      if (!card) return 0;
      const styles = getComputedStyle(row);
      const gap = parseFloat(styles.columnGap || styles.gap) || 12;
      return card.getBoundingClientRect().width + gap;
    };

    const apply = () => {
      const width = loopWidth();
      if (width > 0) {
        offset %= width;
        if (offset < 0) offset += width;
      }
      row.scrollLeft = offset;
    };

    prev.addEventListener('click', () => {
      offset -= step();
      apply();
    });

    next.addEventListener('click', () => {
      offset += step();
      apply();
    });

    const tick = (now) => {
      if (!last) last = now;
      const delta = Math.min(now - last, 40);
      last = now;
      if (inView && !reduced) {
        offset += (speed * delta) / 1000;
        apply();
      }
      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);

    const sectionObserver = new IntersectionObserver((entries) => {
      inView = entries.some((entry) => entry.isIntersecting);
    }, { threshold: 0.35 });

    sectionObserver.observe(section);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.35 });

    videos.forEach((video) => observer.observe(video));
  });

  } catch(e) { console.error(e); }
})();
})();
